function addDragFunctionalityToSlider(sliderElement) {
  let isDragging = false;
  let startX = 0;
  let scrollLeft = 0;

  function handleDragStart(event) {
    isDragging = true;
    startX = event.pageX - sliderElement.offsetLeft;
    scrollLeft = sliderElement.scrollLeft;
  }

  function handleDragMove(event) {
    if (!isDragging) return;

    event.preventDefault();
    const x = event.pageX - sliderElement.offsetLeft;
    const walk = (x - startX) * 2; // Ajusta el multiplicador para la sensibilidad
    sliderElement.scrollLeft = scrollLeft - walk;
  }

  function handleDragEnd() {
    isDragging = false;
  }

  function handleSelectStart(event) {
    event.preventDefault();
  }

  sliderElement.addEventListener("mousedown", handleDragStart);
  sliderElement.addEventListener("mousemove", handleDragMove);
  sliderElement.addEventListener("mouseup", handleDragEnd);
  sliderElement.addEventListener("mouseleave", handleDragEnd);
  sliderElement.addEventListener("selectstart", handleSelectStart); // Agrega este listener
}

document
  .querySelectorAll(".collection-list.slider--everywhere")
  .forEach((sliderElement) => {
    addDragFunctionalityToSlider(sliderElement);
  });

// Sticky header with transparency
const header = document.querySelector("sticky-header");
const announcementBar = document.querySelector(".announcement-bar-section");

if (header) {
  const headerHeight = header.offsetHeight;
  const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
  const height = headerHeight + announcementBarHeight;

  window.addEventListener("scroll", () => {
    if (window.scrollY <= height) {
      header.classList.add("header-transparent");
    } else {
      header.classList.remove("header-transparent");
    }
  });
}
